'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http) {
    this.$http = $http;
  }

  $onInit() {
    this.getBetaUsers();
  }

  getBetaUsers() {
    this.$http.get('/api/betaUsers').then(res => {
      this.betausers = res.data;
    });
  }

  delete(id) {
    if (confirm("确定？")) {
      this.$http.delete(`/api/betaUsers/${id}`).then(res => {
        this.getBetaUsers();
      });
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/betausers/list/list.controller.js